import { useDispatch } from "react-redux";
import { useEffect } from "react";
import { actionAuthorizeUser, actionUnauthorizeUser } from "redux/slices/authorizationSlice";
import { getStorageAuthKeys } from "utils/auth";

const useCheckAuthorizationKeys = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    const hasAuthorizationKeys: boolean = !!getStorageAuthKeys();

    if (hasAuthorizationKeys) {
      dispatch(actionAuthorizeUser());
    } else {
      dispatch(actionUnauthorizeUser());
    }

    return;
  }, []);

  return null;
};

export default useCheckAuthorizationKeys;
